import React from 'react';
export function Stores() {
  const stores = ['Truworths', 'Edgars', 'Mr Price', 'Foschini', 'Woolworths', 'Markham', 'Totalsports'];
  return <section className="py-16 bg-ink border-y border-white/5" data-id="element-395">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-396">
        <p className="text-xs font-medium text-muted uppercase tracking-[0.3em] mb-10" data-id="element-397">
          Built with South Africa's leading retailers
        </p>
        <div className="flex flex-wrap justify-center items-center gap-x-12 gap-y-6" data-id="element-398">
          {stores.map(store => <div key={store} className="display-italic text-2xl md:text-3xl text-bone-dim/60 hover:text-bone transition-colors" data-id="element-399">
            
              {store}
            </div>)}
        </div>
      </div>
    </section>;
}